module.exports = __webpack_public_path__ + "img/16_121.71ae36ad.png";